// extracted by mini-css-extract-plugin
module.exports = {"checkboxAdmin":"CheckboxAdmin_checkboxAdmin__3yrh-","labelText":"CheckboxAdmin_labelText__29IFa","disabled":"CheckboxAdmin_disabled__2mxP3"};